import type React from 'react';
import { useCallback } from 'react';
import { di } from 'react-magnetic-di';
import { useRouterActions } from 'react-resource-router';
import { getEnv } from '@atlassian/help-center-common-util/env';

export const useLinkPush = () => {
    di(useRouterActions, getEnv);

    const env = getEnv();
    const { push } = useRouterActions();

    const linkPush = useCallback(
        (targetUrl: string, event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
            if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
            event.preventDefault();
            push(targetUrl) as void;
        },
        [push]
    );

    return {
        push: linkPush,
        baseUrl: env.baseUrl?.replace(/\/+$/, ''),
    };
};
